import React from "react";

function ReferralPolicy() {
  return <div>ReferralPolicy</div>;
}

export default ReferralPolicy;
